<template>
  <Modal v-model="isShow" width="65%" :closable="false" :mask-closable="false">
    <div slot="header" class="info-header">
      <div class="ivu-modal-header-inner">ai用户信息</div>
      <a class="ivu-modal-close" @click="closeModel"><i class="ivu-icon ivu-icon-ios-close"></i></a>
    </div>
    <div>
      <Form ref="aiheaderForm" :model="form" :label-width="80" :rules="ruleValidate">
        <Row>
          <Col span="8">
            <FormItem label="HEADER名称" prop="name">
              <Input v-model="form.name" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="HEADER标识" prop="code">
              <Input v-model="form.code" :disabled="disable"></Input>
            </FormItem>
          </Col>
          <Col span="8">
            <FormItem label="内容" prop="status">
              <Input v-model="form.content" :disabled="content"></Input>
            </FormItem>
          </Col>
        </Row>
      </Form>
    </div>
    <div slot="footer">
      <Button @click="closeModel">取消</Button>
      <Button type="primary" @click="submit"  v-show="!disable">提交</Button>
    </div>
  </Modal>
</template>

<script>

export default {
  name: 'aiheader-info',
  data () {
    return {
      form: {},
      isShow: false,
      type: 'add',
      disable: false,
      statusOptions: [
        { key: 0, name: '禁用' },
        { key: 1, name: '启用' }
      ],
      ruleValidate: {
        id: [
          { required: true, message: 'ID不允许为空', trigger: 'blur' }
        ],
        name: [
          { required: true, message: 'HEADER名称不允许为空', trigger: 'blur' }
        ],
        code: [
          { required: true, message: 'HEADER标识不允许为空', trigger: 'blur' }
        ],
        content: [
          { required: true, message: '内容不允许为空', trigger: 'blur' }
        ],
        crtUserId: [
          { required: true, message: '创建用户Id不允许为空', trigger: 'blur' }
        ],
        crtTime: [
          { required: true, message: 'CrtTime不允许为空', trigger: 'blur' }
        ],
        mdfUserId: [
          { required: true, message: 'MdfUserId不允许为空', trigger: 'blur' }
        ],
        mdfTime: [
          { required: true, message: 'MdfTime不允许为空', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    openModel (type, data) {
      this.isShow = true
      this.type = type
      if (data) {
        this.form = data
      } else {
        this.form = {}
      }
      this.disable = type === 'detail'
    },
    closeModel () {
      this.isShow = false
    },
    submit () {
      this.$refs.aiheaderForm.validate((valid) => {
        if (valid) {
          switch (this.type) {
            case 'create':
              this.C('aiheader', this.form).then(data => {
                this.isShow = false
                this.$emit('handle-search')
              })
              break
            case 'update':
              this.U('aiheader', this.form).then(data => {
                this.isShow = false
                this.$emit('handle-search')
              })
              break
          }
        } else {
          this.$Message.error('请检查填写的数据')
        }
      })
    }
  },
  mounted: function () {
  }
}
</script>
